/**
 * Device Web CLI policy — the client mirror of services/device_terminal.py.
 *
 * TERMINAL_MIN_ROLE MUST equal the backend's TERMINAL_MIN_ROLE (api/v2/device_terminal.py
 * enforces it with @require). The SPA only uses it to hide the button; the server is the
 * enforcement. A root shell on a network device is the most powerful action in Meridian, so
 * it is msp_admin for now. Lowering it (e.g. to org_admin) is a change in BOTH places.
 */
import type { Role } from "@/types/domain";

export const TERMINAL_MIN_ROLE: Role = "msp_admin";

/** Device kinds that run an rtty client owgw can start: OpenWrt APs/gateways, OLS switches. */
export const TERMINAL_KINDS: ReadonlySet<string> = new Set(["access_point", "gateway", "switch"]);

export function supportsTerminal(kind: string | undefined | null): boolean {
  return !!kind && TERMINAL_KINDS.has(kind);
}
